"use client"

import { MailPlus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MailPlusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MailPlusIcon = component(Icon)({ as: MailPlus })
